import { AbnormalStatus } from './abnormal-status';
import { ReviewedStatus } from './reviewed-status';

export interface IFilterData {
    registrationStartDate: string,
    registrationEndDate: string,
    resultsDate: string,
    reviewedStatus: ReviewedStatus,
    abnormalStatus: AbnormalStatus,
}